import React, { FC } from 'react';

const SmartlineLogo: FC = () => (
  <svg
    width="90px"
    height="20px"
    viewBox="37 30 400.06 92.08"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#e21e2d"
      d="M29.94,75.73A46,46,0,1,0,76.23,29.94H76A46,46,0,0,0,29.94,75.73Z"
    />
    <path
      fill="#fff"
      d="M92.46,102.82H60.26a4.62,4.62,0,0,1-4.61-4.62V79.27H51.79a4.61,4.61,0,0,1-3.28-7.87L73.09,46.71a4.61,4.61,0,0,1,6.54,0L104.21,71.4a4.61,4.61,0,0,1-3.28,7.87H97.07V98.2A4.62,4.62,0,0,1,92.46,102.82ZM76.36,49.35a.57.57,0,0,0-.43.18L51.35,74.22a.6.6,0,0,0-.13.67.61.61,0,0,0,.57.38h5.86a2,2,0,0,1,2,2V98.2a.61.61,0,0,0,.61.62h32.2a.61.61,0,0,0,.61-.62V77.27a2,2,0,0,1,2-2h5.86a.61.61,0,0,0,.57-.38.6.6,0,0,0-.13-.67L76.8,49.53A.6.6,0,0,0,76.36,49.35Z"
    />
    <path
      fill="currentColor"
      d="m138.38 84.93 7.79-2.54c1.12 5.08 5 7.55 9.87 7.55 4.34 0 7-1.42 7-3.74s-2.04-3.2-6.77-4.41l-3.82-0.9c-8.9-2.17-12.64-5.91-12.64-12 0-6.89 6.06-11.53 15.41-11.53 9 0 15.64 4.72 16.69 12.42l-8 2.1c-0.82-4.71-4.34-6.66-8.68-6.66-3.82 0-6.29 1.5-6.29 3.44 0 2.47 2.85 3.29 7.41 4.42l3.74 1c8.16 1.94 12.2 5.84 12.2 11.67 0 7.11-6.44 12-16.24 12-8.24-0.03-15.57-3.99-17.67-12.82z"
    />
    <path
      fill="currentColor"
      d="m232.59 71.39v25.44h-9.65v-23.5c0-4.86-2.55-7.56-6-7.56-4.11 0-7.11 2.85-7.11 7.86v23.2h-9.65v-23.5c0-4.86-2.54-7.56-6-7.56-4.12 0-7.11 2.85-7.11 7.86v23.2h-9.66v-38.54h9.66v4.79a10.68 10.68 0 0 1 10-5.69 12.09 12.09 0 0 1 11 6.36c2.32-4.49 6.36-6.36 11.22-6.36 7.61 0 13.3 5.54 13.3 14z"
    />
    <path
      fill="currentColor"
      d="m272.32 72.58v24.25h-9v-3.74c-2.32 3.06-6.29 4.63-11.38 4.63-9 0-14.89-4.48-14.89-12 0-7.26 6.14-12 15.57-12 4.41 0 7.78 1.27 10 3.36v-3.52c0-5.17-3-7.56-8-7.56a8.63 8.63 0 0 0-8.61 6.13l-8-3.36c2.62-8.16 9.36-11.38 17-11.38 9.31 0 17.31 4.79 17.31 15.19zm-9.42 13c0-3.29-3.22-5.16-7.94-5.16s-7.96 1.89-7.96 5.18 3.22 5.09 7.93 5.09 7.97-1.79 7.97-5.09z"
    />
    <path
      fill="currentColor"
      d="M300.09,57.39V67.72h-4c-4.49,0-7.7,3.22-7.7,8.9V96.83h-9.65V58.29h9.65v5.54c2.17-4.49,5.68-6.44,9.72-6.44Z"
    />
    <path
      fill="currentColor"
      d="M327.57,66H319V83c0,3.67,1.49,5.54,4.49,5.54h4.11v8.31h-5.31c-8.23,0-12.95-5.17-12.95-13.4V66h-7V58.29h7V50.88L319,45.57V58.29h8.6Z"
    />
    <path
      fill="currentColor"
      d="m343.36 96.83c-7.11 0-11.15-4.34-11.15-11.38v-41h9.65v40.41c0 2.39 1.05 3.66 3.37 3.66h2.84v8.31z"
    />
    <path
      fill="currentColor"
      d="m350.62 48.12c0-3.6 2.77-5.84 6.21-5.84s6.17 2.24 6.17 5.84-2.77 5.76-6.21 5.76-6.17-2.1-6.17-5.76zm11 10.17v38.54h-9.62v-38.54z"
    />
    <path
      fill="currentColor"
      d="m402.25 72v24.83h-9.66v-23.2c0-5-2.84-7.86-6.73-7.86-4.56 0-7.86 3.07-7.86 8.38v22.68h-9.65v-38.54h9.65v5c2.32-4.19 6.21-5.91 10.55-5.91 7.86 0.01 13.7 5.77 13.7 14.62z"
    />
    <path
      fill="currentColor"
      d="m443.92 79.69h-27.16c0.6 6.81 4.19 9.8 9.13 9.8 4.57 0 7.86-2.09 9.88-7.33l8.15 3c-3 8.68-9.8 12.57-17.65 12.57-11.38 0-19.31-8.08-19.31-20.2 0-12 7.78-20.13 18.86-20.13 10.7 0 18.18 8.08 18.18 20.06a21 21 0 0 1-0.08 2.23zm-26.86-6.58h17.14c-1.05-5.47-4.12-7.93-8.38-7.93-4.72 0-7.71 2.61-8.76 7.93z"
    />
  </svg>
);
export default SmartlineLogo;
